import styled from "@emotion/styled";

const OverflowedOptionWrapper = styled.div`
  width: 100%;
`;

export { OverflowedOptionWrapper };
